import DiagramViewerClientDataHistory from "../../../../content/blog/data-challenges-history/DiagramViewerClientDataHistory.js";
import WarehouseAnimation from "../../../../content/blog/data-challenges-history/WarehouseAnimation.js";
import * as React from 'react';
export default {
  DiagramViewerClientDataHistory,
  WarehouseAnimation,
  React
};